import IconDelivery from '@/asset/icons/delivery';
import IconPickup from '@/asset/icons/pickup';
import IconShipping from '@/asset/icons/shipping';
import { DEFAULT_FONT_SIZE } from '@/constants';
import { ClassEnum, COLOR_SCHEME_OPTIONS, HeaderRadioDirection, LAYOUT_OPTIONS, SETTING_TYPE } from '@/constants/enum';
import { getColor } from '@/helpers';
import { previewOptionSelector } from '@/redux/slice/preview.slice';
import { widgetColorSelector, widgetSettingSelector } from '@/redux/slice/widget.slice';
import { widgetTextDetailSelector } from '@/redux/slice/widgetText.slice';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import HeaderDropdown from './components/HeaderDropdown';
import HeaderRadio from './components/HeaderRadio';

const Header = () => {
  const widgetSettings = useSelector(widgetSettingSelector);
  const widgetColors = useSelector(widgetColorSelector);
  const widgetTextDetail = useSelector(widgetTextDetailSelector);
  const previewOptions = useSelector(previewOptionSelector);

  const widgetShippingTexts = useMemo(
    () => widgetTextDetail.texts?.find((item) => item.type === SETTING_TYPE.SHIPPING),
    [widgetTextDetail.texts],
  );

  const widgetDeliveryTexts = useMemo(
    () => widgetTextDetail.texts?.find((item) => item.type === SETTING_TYPE.DELIVERY),
    [widgetTextDetail.texts],
  );

  const widgetPickupTexts = useMemo(
    () => widgetTextDetail.texts?.find((item) => item.type === SETTING_TYPE.PICKUP),
    [widgetTextDetail.texts],
  );

  const enableMethods = useMemo(
    () => previewOptions.methods.filter((item) => item.isEnable).map((item) => item.key),
    [previewOptions.methods],
  );

  const methodOptions = useMemo(() => {
    const sortOrder = {
      [widgetSettings.sortMethods[0]]: 0,
      [widgetSettings.sortMethods[1]]: 1,
      [widgetSettings.sortMethods[2]]: 2,
    };

    return [
      {
        value: SETTING_TYPE.SHIPPING,
        label: widgetShippingTexts?.labelAndButtons?.buttonLabel,
        icon: IconShipping,
      },
      {
        value: SETTING_TYPE.DELIVERY,
        label: widgetDeliveryTexts?.labelAndButtons?.buttonLabel,
        icon: IconDelivery,
      },
      {
        value: SETTING_TYPE.PICKUP,
        label: widgetPickupTexts?.labelAndButtons?.buttonLabel,
        icon: IconPickup,
      },
    ]
      .filter((option) => enableMethods.includes(option.value))
      .sort((a, b) => sortOrder[a.value] - sortOrder[b.value]);
  }, [
    enableMethods,
    widgetDeliveryTexts?.labelAndButtons?.buttonLabel,
    widgetPickupTexts?.labelAndButtons?.buttonLabel,
    widgetSettings.sortMethods,
    widgetShippingTexts?.labelAndButtons?.buttonLabel,
  ]);

  return (
    <div className={ClassEnum.Header} id="fulfillment-method-wrapper">
      {!widgetSettings.widgetMethods.hideHeadingTitle ? (
        <>
          <label
            className={ClassEnum.HeaderTitle}
            style={{
              fontSize: widgetSettings.sizes.headingFontSize || DEFAULT_FONT_SIZE,
              color: getColor(widgetSettings.colorScheme, widgetColors, 'header', 'headerTitleColor'),
            }}
            id="fulfillment-method-label"
          >
            {widgetTextDetail.headerTitle}
          </label>
          {widgetTextDetail.additionalMessage && (
            <p
              className={ClassEnum.HeaderAdditionalMessage}
              id="fulfillment-method-addtional-message"
              style={{
                color: widgetSettings.colorScheme === COLOR_SCHEME_OPTIONS.DARK ? 'rgb(255, 255, 255)' : 'rgb(107, 114, 128)',
                fontSize: widgetSettings.sizes.additionalMessageFontSize,
              }}
            >
              {widgetTextDetail.additionalMessage}
            </p>
          )}
        </>
      ) : null}
      {previewOptions.methods.filter((item) => item.isEnable).length > 1 || !widgetSettings.widgetMethods.hideHeader ? (
        <>
          {widgetSettings.widgetMethods.layout === LAYOUT_OPTIONS.HORIZONTAL && (
            <HeaderRadio direction={HeaderRadioDirection.HORIZONTAL} options={methodOptions} />
          )}
          {widgetSettings.widgetMethods.layout === LAYOUT_OPTIONS.VERTICAL && (
            <HeaderRadio direction={HeaderRadioDirection.VERTICAL} options={methodOptions} />
          )}
          {widgetSettings.widgetMethods.layout === LAYOUT_OPTIONS.DROPDOWN && <HeaderDropdown options={methodOptions} />}
        </>
      ) : null}
    </div>
  );
};

export default Header;
